import { render, staticRenderFns } from "./ThreeDotsMenu.vue?vue&type=template&id=5153c4b6&scoped=true&"
import script from "./ThreeDotsMenu.vue?vue&type=script&lang=ts&"
export * from "./ThreeDotsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ThreeDotsMenu.vue?vue&type=style&index=0&id=5153c4b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153c4b6",
  null
  
)

export default component.exports